import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import EmailMaker from './email';
import Temp from './temp';
import Home from './Pages/Home';
import Emails from './Pages/Emails';
import Navbar from './Components/Navbar';
import NavbarTop from './Components/Navbar';
import Footer from './Components/Footer';
import FormEn from './Pages/FormEn';
import PromotionalEn from './Pages/PromotionalEn';
import SegmentedEn from './Pages/SegmentedEn';
import Success from './Pages/Success';
import PromotionalFr from './Pages/PromotionalFr';
import PromotionalEx from './Pages/experiment';
import SegmentedFr from './Pages/SegmentedFr';
import Login from './Pages/Login';
import ClearanceEn from './Pages/ClearanceEn';
import SSGPEN from './Pages/SSGPEN';
import ClearanceFr from './Pages/ClearanceFr';
import SSGPFR from './Pages/SSGPFR';
import UserManagement from './Pages/Admin';
import AdminLogin from './Pages/AdminLogin';
import Admin from './Pages/Admin';
import GtaEn from './Pages/GTAEN';
import PromotionalEnTest from './Pages/PromotionalEnTest';
import PromotionalFrTest from './Pages/PromotionalFrTest';
import GMA from './Pages/GMA';
import GMAFr from './Pages/GMAFr';
import SegmentedEnTest from './Pages/SegmentedEnTest';
import SegmentedFrTest from './Pages/SegmentedFrTest';

function App() {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem("isLoggedIn") === "true";
  const isAuthenticated1 = localStorage.getItem("adminToken");
  const isAdmin = localStorage.getItem("role") === "admin";

  return (
    <>
      {location.pathname !== "/" && location.pathname !== "/admin-login" && <NavbarTop />}
      <Routes>
        
        <Route
          path="/"
          element={isAuthenticated ? <Navigate to="/home" replace /> : <Login />}
        />

        
        <Route
          path="/home"
          element={isAuthenticated ? <Home /> : <Navigate to="/" replace />}
        />

        
        <Route path="/temp" element={<Temp />} />
        <Route path="/email" element={<Emails />} />
        <Route path="/form-en" element={<FormEn />} />
        <Route path="/form" element={<EmailMaker />} />
        <Route path="/promotional-en" element={<PromotionalEn />} />
        <Route path="/promotional-en-test" element={<PromotionalEnTest />} />
        <Route path="/promotional-fr-test" element={<PromotionalFrTest />} />
        <Route path="/promotional-ex" element={<PromotionalEx />} />
        <Route path="/promotional-fr" element={<PromotionalFr />} />
        <Route path="/segmented-en-test" element={<SegmentedEnTest />} />
        <Route path="/segmented-en" element={<SegmentedEnTest/>} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/segmented-fr-test" element={<SegmentedFr />} />
        <Route path="/segmented-fr" element={<SegmentedFrTest />} />
        <Route path="/clearance-en" element={<ClearanceEn />} />
        <Route path="/clearance-fr" element={<ClearanceFr />} />
        <Route path="/gta-en" element={<GtaEn />} />
        <Route path="/gma" element={<GMA />} />
        <Route path="/gma-fr" element={<GMAFr />} />
        <Route path="/ssgp-en" element={<SSGPEN />} />
        <Route path="/ssgp-fr" element={<SSGPFR />} />
        <Route path="/success" element={<Success />} />
        <Route path="/admin" element={isAuthenticated1 && isAdmin ? <Admin /> : <Navigate to="/admin-login" />} />
      </Routes>
      {location.pathname !== "/" && location.pathname !== "/admin-login" && <Footer />}

    </>
  );
}


export default App;
